import { createContext, ReactNode, useContext } from 'react';

const AiFeedbackOverlayVisibleContext = createContext<boolean>(false);

export const AiFeedbackOverlayVisibleProvider = ({
  visible,
  children,
}: {
  visible: boolean;
  children: ReactNode;
}) => (
  <AiFeedbackOverlayVisibleContext.Provider value={visible}>
    {children}
  </AiFeedbackOverlayVisibleContext.Provider>
);

export const useAiFeedbackOverlayVisible = (): boolean =>
  useContext(AiFeedbackOverlayVisibleContext);
